import { render, staticRenderFns } from "./listaTipoProtocolo.vue?vue&type=template&id=30787837&scoped=true&"
import script from "./listaTipoProtocolo.vue?vue&type=script&lang=js&"
export * from "./listaTipoProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./listaTipoProtocolo.vue?vue&type=style&index=0&id=30787837&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30787837",
  null
  
)

export default component.exports